// @ts-ignore
import React, { useContext, useRef } from "react";
import ThemeToggle from "./ThemeToggle";
import LogOut from "../Svgs/Logout.svg";
// @ts-ignore
import { signOut } from "firebase/auth";
// @ts-ignore
import { auth } from "../firebase.config";
import { Switch } from "./ui/switch";
import { Atom, LogOutIcon, Mic, MicOff } from "lucide-react";
import { AuthContext } from "../context/AuthContext";

// @ts-ignore
const Header = ({
  orgLogo,
  orgLogo_dark,
  orgName,
  handleLogout,
  setShowMenu,
  showMenu,
  voiceMode,
  setVoiceMode,
}) => {
  const hamRef = useRef(null);
  const { theme } = useContext(AuthContext);


  return (
    <header className="shadow-sm max-sm:p-5">
      <div className="flex justify-start w-full gap-5 align-middle">
        <svg
          className="ham hamRotate ham4"
          viewBox="0 0 100 100"
          width="40"
          stroke={theme == "dark" ? "#ffffff" : "#000000"}
          ref={hamRef}
          onClick={() => {
            hamRef.current.classList.toggle("active");
            setShowMenu(!showMenu);
          }}
        >
          <path
            className="line top"
            d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20"
          />
          <path className="line middle" d="m 70,50 h -40" />
          <path
            className="line bottom"
            d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20"
          />
        </svg>
        <h1>
          <img
            src={theme == "dark" ? orgLogo_dark : orgLogo}
            alt={`${orgName} Icon`}
            style={{
              height: 30,
              width: "auto",
              maxWidth: "200px",
            }}
            onError={(e) => {
              // @ts-ignore
              e.target.onerror = null;
              // @ts-ignore
              e.target.src = "/X.png";
            }}
          />
        </h1>
      </div>
      <div className="header-controls">
        <ThemeToggle />
        <div className="header-controls">
          {/* <ThemeToggle /> */}
          <div className="flex items-center gap-3 px-1.5 py-1.5 rounded-lg hover:bg-secondary/50 transition-colors">
            <Switch
              checked={voiceMode}
              onCheckedChange={setVoiceMode}
              className="data-[state=checked]:bg-primary/90 data-[state=unchecked]:bg-muted"
            />
            <div className="flex items-center gap-2">
              <Atom width={20} height={20}/>
            </div>
          </div>
        </div>
        <button onClick={handleLogout} className="logout-button" title="Logout">
          <LogOutIcon alt="Logout" width={20} height={20}/>
        </button>
      </div>
    </header>
  );
};

export default Header;
